import { render, staticRenderFns } from "./all_live.vue?vue&type=template&id=502487d8"
import script from "./all_live.vue?vue&type=script&lang=js"
export * from "./all_live.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports